




































































































































































































































































































































































































































































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';

import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({

})
export default class Home extends Mixins(VueHoduCommon) {

    mounted() {
        
        // @ts-ignore
        $('.slider').slick({
            dots: true,
            autoplay: false,
            arrows: true,
            customPaging: function(slider, i) {
                // console.log($(slider.$slides[i]).html());
                return '<button class="tab">' + $(slider.$slides[i]).find('.slide_img').attr('data-dot-title') + '</button>';
            },
            //반응형 속성 설정
            responsive: [{
                breakpoint: 768, // 화면의 넓이가 768px 이상일 때
                settings: {

                }
            }]
        });

        // // 두번째 섹션 네비게이션 클릭이벤트
        // $(".ware_features_nav li a").click(function(){
        //     // 왼쪽 네비게이션 클릭시 하이퍼링크태그에 on빼기
        //     $(this).parent().siblings().find("a").removeClass("on");
        //     $(this).addClass("on");


        //     // 클릭된 인덱스 가져오기
        //     var getIndex = $(this).parent().index();

        //     // 오른쪽 페이지 변경
        //     $(".ware_features_img_ul li").eq(getIndex).siblings().removeClass("on");	
        //     $(".ware_features_img_ul li").eq(getIndex).addClass("on");


        //     return false;
        // });

        // // 두번째 섹션 네비게이션 클릭이벤트
        // $(".ware_biz_nav li a").click(function(){
        //     // 왼쪽 네비게이션 클릭시 하이퍼링크태그에 on빼기
        //     $(this).parent().siblings().find("a").removeClass("on");
        //     $(this).addClass("on");


        //     // 클릭된 인덱스 가져오기
        //     var getIndex = $(this).parent().index();

        //     // 오른쪽 페이지 변경
        //     $(".ware_biz_ul li").eq(getIndex).siblings().removeClass("on");	
        //     $(".ware_biz_ul li").eq(getIndex).addClass("on");


        //     return false;
        // });
    }

    /**
     * 주요 기능으로 이동
     */
    goFeatures(tab : string) : void {
        this.doSetFeaturesTab(tab);
        this.$router.push('/features').catch(e => {});
    }

    /**
     * 문의하기로 이동
     */
    goQuestion(tab : string) : void {
        this.doSetServiceCenterTab(tab);
        this.$router.push('/serviceCenter').catch(e => {});
    }
}
